import { render, staticRenderFns } from "./UpdateTransactionComission.vue?vue&type=template&id=353ccb13&"
import script from "./UpdateTransactionComission.vue?vue&type=script&lang=js&"
export * from "./UpdateTransactionComission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports